/**
 * Ensure that a value is valid int or try to convert it.
 * Throws otherwise
 * @params {unknown} value;
 * @param {number} value
 */
import { get } from "~/lib/helpers/objects";

export function ensureInt(value: unknown): number {

  if( typeof value === "number" &&  isNaN(value) === false) {
    return value;
  }

  if( typeof value === "string") {
    value = parseInt(value, 10);
    return ensureInt(value);
  }

  throw new Error("number required");
}

/**
 * Test typeof !== "undefined" || null on value
 * Is recursive, so works nested object properties
 *
 * @param {any} value value to be tested
 * @param {string} [path] recursive path if
 */
export function isDefined(value: any, path?: string): boolean {
  if (path) {
    if(typeof value === "undefined" || value === null  ) return false;
    if (!isObject(value)) {
      throw new Error("Cannot recurse a path on a non object value");
    }
    value = get(value, path);
  }
  return typeof value !== "undefined" && value !== null;
}


export function isFunction(x: unknown): x is Function {
  return typeof x === 'function';
}

export function isString(x: unknown): x is string {
  return typeof x === 'string';
}

export function isObject(value: any): value is ObjectLiteral {
  return isDefined(value) && value.toString() === Object().toString();
}

export function isInt(value: number): boolean {
  return Math.floor(value) === value;
}

export function isFloat(value: number): boolean{
  return !!(value % 1);
}
